/**
 * @param {Set} set
 * @param {Iterable} subset
 * @return {Boolean} whether `set` contains every element of `subset`
 */
const isSuperset = (set, subset) => {
  for (const element of subset) {
    if (!set.has(element)) {
      return false;
    }
  }

  return true;
};

export default isSuperset;
